import { Dialog, DialogTitle, DialogContent, Radio, Button } from '@mui/material';
import React, { useState, useMemo } from 'react';
import { useMyContext } from '../../../context/MyContext';
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import { useNavigate } from 'react-router-dom';
import { IoIosCloseCircle } from "react-icons/io";
import Spinner from '../../../component/spinner/spinner';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Base_Url, csvuplodeprocess } from '../../../config/config';
import '../../css/custom-scrollbar.css';

const ConfirmBulkOrder = ({ isopen, onClose, data, file }) => {
  const { isDarkMode } = useMyContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const [selectedRowId, setSelectedRowId] = useState(null);
  // const [selectedRowData, setSelectedRowData] = useState([]);
  const userData = JSON.parse(localStorage.getItem('user')) || {};


  const handleNavigation = () => {
    navigate('/shipments/bulkUpload');
  };

  // Dynamic table data generation with support for future partner additions
  const tableData = useMemo(() => {
    if (!data?.data?.partners_pricing) return [];

    // Collect all partners dynamically
    const allPartners = Object.keys(data.data.partners_pricing);

    // Flatten and transform pricing data for all partners
    return allPartners.flatMap(partner =>
      Object.entries(data.data.partners_pricing[partner] || {}).map(([mode, pricing], index) => ({
        id: `${partner}-${mode}-${index}`,
        courier: partner.toLowerCase(),
        mode,
        zone: data.data.zone,
        basePrice: pricing.total_price,
        codExtra: pricing.cod_extra,
        // Handling cases where cod_total_price might be 0
        codTotalPrice: pricing.cod_total_price !== 0
          ? pricing.cod_total_price
          : pricing.total_price,
        shippingMode: mode,
        // Spread any additional partner-specific data
        ...pricing
      }))
    );
  }, [data]);

  // const handleRadioChange = (event, row) => {
  //   setSelectedRowId(row.id);
  //   setSelectedRowData(row);
  // };

  const handleSubmit = async (event) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    setIsSubmitting(true);
    // const shipment_type = "forword";
    const formData = new FormData();
    // formData.append('csv_file', file);
    formData.append('file_path', data?.data?.file_path);
    formData.append("response", "yes");
    formData.append("shipment_type", data?.data?.shipment_type);
    try {
      const response = await axios.post(Base_Url + csvuplodeprocess, formData, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        setIsSubmitting(false);
        handleClose();
        handleNavigation();

      } else {
        toast.error("File uploading failed");
        setIsSubmitting(false);
      }
    } catch (error) {
      toast.error("Error uploading file: " + error.message);
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    onClose();
  };


  const tableHeaders = useMemo(() => {
    const baseHeaders = [
      // 'Select', 
      'Courier Name',
      'Mode',
      'Zone',
      'Forward Price',
      'COD Price',
      'Total Price'
    ];

    return baseHeaders;
  }, [tableData]);

  return (
    <Dialog
      open={isopen}
      onClose={onClose}
      maxWidth="lg"
      sx={{
        '& .MuiDialog-paper': {
          width: '80%',
          height: '80vh',
        }
      }}
    >
      <DialogTitle className="bg-customPurple text-white text-center">
        <h2 className="text-2xl font-semibold flex items-center justify-center">
          <RiMoneyRupeeCircleFill />
          Estimate Price For All Carriers
        </h2>
        <IoIosCloseCircle
          className="absolute top-2 right-2 cursor-pointer"
          size={32}
          onClick={handleClose}
        />
      </DialogTitle>

      <DialogContent
        className={`shadow-custom-light rounded-custom dark:shadow-custom-dark mt-4 ml-2 mr-2 mb-4 p-4 
        ${isDarkMode ? "dark:bg-darkmodeColor text-white" : ""}`}
        sx={{ overflowY: 'auto' }}
      >
        <div className="overflow-x-auto md:mt-8 md:mb-8 md:ml-8 md:mr-8">
          <table border={1} className="min-w-full mt-3 md:mt-5 table-auto">
            <thead className="bg-[#0540a6dd] text-white text-[12px]">
              <tr>
                {tableHeaders.map((header, index) => (
                  <th key={index} className="p-2 text-left">{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {tableData.length > 0 ? (
                tableData.map((row) => (
                  <tr key={row.id} className="border-b">
                    {/* <td className="p-2">
                      <Radio
                        checked={selectedRowId === row.id}
                        onChange={(event) => handleRadioChange(event, row)}
                        value={row.id}
                        name="selectRow"
                        inputProps={{ 'aria-label': 'select row' }}
                      />
                    </td> */}
                    <td className="p-2">{row.courier}</td>
                    <td className="p-2">{row.mode || "N/A"}</td>
                    <td className="p-2">{row.zone || "N/A"}</td>
                    <td className="p-2">{row.basePrice ? `₹ ${row.basePrice}` : "N/A"}</td>
                    <td className="p-2">{row.codExtra ? `₹ ${row.codExtra}` : "N/A"}</td>
                    <td className="p-2">{row.codTotalPrice ? `₹ ${row.codTotalPrice}` : "N/A"}</td>
                    {/* Render any additional dynamic fields */}

                  </tr>
                ))
              ) : (
                <tr>
                  <td className="p-2 text-center" colSpan={tableHeaders.length}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </DialogContent>

      <div className="flex flex-col md:flex-row justify-end gap-4 p-4 z-10">
        <button
          className="w-full md:w-[200px] bg-red-600 hover:bg-red-700 text-white font-semibold py-2 rounded-xl shadow transition"
          onClick={handleClose}
        >
          Cancel Orders in Bulk
        </button>

        <button
          className={`w-full md:w-[200px] bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded-xl shadow transition ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
            }`}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? <Spinner /> : "Confirm Orders In Bulk"}
        </button>
      </div>
    </Dialog>
  );
};

export default ConfirmBulkOrder;
